/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
require('@rails/ujs').start()
require('turbolinks').start()
require('jquery') // for cocoon
require('@nathanvda/cocoon') // for nested forms

import '@popperjs/core'
import * as bootstrap from 'bootstrap'
import 'stylesheets/application'

import axios from 'axios'
window.axios = axios

// StimulusJS
import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'
const application = Application.start()
const context = require.context('./../controllers', true, /\.js$/)
application.load(definitionsFromContext(context))

// react_rails gem setup
// Support component names relative to this directory:
var componentRequireContext = require.context('components', true)
var ReactRailsUJS = require('react_ujs')
ReactRailsUJS.useContext(componentRequireContext)

// Bootstrap - enable tooltips and popovers
document.addEventListener('DOMContentLoaded', function (event) {
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  )
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  )
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
  })
})

// document.addEventListener("DOMContentLoaded", function () {
//   var swiper = new Swiper(".swiper-container", {
//     slidesPerView: 1.5, // Show 2.5 slides at initial slide
//     spaceBetween: 30,
//     centeredSlides: false, // Center the active slide
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//     breakpoints: {
//       768: {
//         slidesPerView: 2.5, // Show 2.5 slides at a time on medium screens
//         spaceBetween: 30,
//       },
//       1024: {
//         slidesPerView: 3.5, // Show 2.5 slides at a time on larger screens
//         spaceBetween: 30,
//       },
//     },
//   });
// });
